import React, { useContext, useEffect, useState } from "react";
import CircularProgress from "@material-ui/core/CircularProgress";
import AssuranceContext from "../../context/index";
import ClaimProcess from "./process";
import CustomerProfile from "./profile";
import Policies from "./policies";
import CustomerDetailsField from "../proposal/partials/field";
import withStyles from "@material-ui/core/styles/withStyles";
import TermsAndCondition from "../../components/common/termsAndCondition";
import {
  Box,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import {
  download,
  extractFileName,
  getApplicationRoute,
  logout,
  redirectWithBlank,
} from "../../helpers/utils";
import {
  buildSystemErrorMessage,
  getCustomerName,
  syncPolicyTermsAndConditionVisibility,
} from "../../helpers/proposal";
import { getWebService } from "../../helpers/server";
import { ReducerUtils } from "../../constants/reducers";
import { useHistory } from "react-router";
import { useStyles } from "./dashboardStyles";
import {
  AUTHORIZATION,
  NEAREST_SERVICE_CENTRES_LIST,
} from "../../constants/index";
import renderHTML from "react-render-html";
import { Images } from "../../constants/images";

function DashboardComponent({
  classes: {
    contentBox,
    bgContainer,
    bgSelected,
    loaderBox,
    main,
    mainContainer,
    performanceCardsBox,
    logoGarantie,
    poweredBy,
    containerLogoGarantie,
  },
  classes,
}) {
  const history = useHistory();

  const { state, dispatch } = useContext(AssuranceContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [modal, setModal] = useState({ open: false, staticPage: false });
  const [preferredServiceCentre, setPreferredServiceCentre] = useState(null);
  const [content, setContent] = useState({ body: null });

  useEffect(() => dispatchEvent(ReducerUtils.search.text, ""), []);

  useEffect(() => fetchDashboardData(), []);

  const cbError = ({ data: { error, error_msg } }) => {
    setIsLoaded(true);
    if (error === AUTHORIZATION) {
      logout();
      window.location.href = "/";
    } else {
      console.log(`error_msg = ${error_msg}`);
    }
  };

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const downloadFile = (url) => redirectWithBlank(url); //download(url, extractFileName(url));

  const getDashboardCards = async () => {
    try {
      const response = await getWebService("my_policies");
      const { data } = response.data;

      dispatchEvent(
        ReducerUtils.products.tndc,
        syncPolicyTermsAndConditionVisibility(data)
      );
      dispatchEvent(ReducerUtils.policies.list, data);
      setIsLoaded(true);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const fetchDashboardData = async () => {
    await getMyProfile();
    await getDashboardCards();
  };

  const getMyProfile = async () => {
    try {
      const response = await getWebService("user/profile");
      const { data } = response.data;

      dispatchEvent(ReducerUtils.user.profile, data);
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const fetchServiceCentres = async ({ city_id = null }) => {
    try {
      const response = await getWebService(
        `service_centres?city_id=${city_id}`
      );
      const { data } = response.data;

      dispatchEvent(ReducerUtils.serviceCentres.list, data);
      toggleModal();
    } catch (error) {
      cbError(
        error && error.response && error.response.data
          ? error.response.data
          : buildSystemErrorMessage()
      );
    }
  };

  const toggleModal = (key = "open", value = true) => {
    setModal({
      ...modal,
      [key]: value,
    });
  };

  const handleViewClick = (item) => {
    setPreferredServiceCentre({ ...item });
    fetchServiceCentres(item.preferred_service_centre);
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const onClickHandler = ({ id, claim_id: claimId = "", status_id }) => {
    if (status_id !== 21) {
      return false;
    }

    let url = `${getApplicationRoute("newClaim")}/?ref=${id}`;

    if (claimId && localStorage.getItem("skip_copayment") === "false") {
      url += `&claim=${claimId}`;
    }

    navigateTo(url);
  };

  const handleStaticPageClick = async (url) => {
    // console.log(`keyname = ${keyname}`);
    // try {
    //   const response = await getWebService(keyname);
    //   const {
    //     data: { content: body },
    //   } = response.data;

    //   setContent({
    //     ...content,
    //     title,
    //     body,
    //   });
    //   toggleModal("staticPage", true);
    // } catch (error) {
    //   cbError(
    //     error && error.response && error.response.data
    //       ? error.response.data
    //       : buildSystemErrorMessage()
    //   );
    // }
    window.open(url, "_blank");
  };

  return (
    <>
      {isLoaded ? (
        <Box className={main}>
          <Box className={mainContainer}>
            <Box className={contentBox}>
              <>
                <Box className={classes.backSolid}>
                  <Box>
                    <Typography variant={"body2"}>
                      <strong>Hi {getCustomerName()}</strong>
                    </Typography>
                    <Typography variant="body2">
                      Welcome to the customer portal
                    </Typography>
                  </Box>
                  <Box className={performanceCardsBox}>
                    <Grid container justifyContent={"center"}>
                      <CustomerProfile downloadFile={downloadFile} />

                      <Policies
                        downloadFile={downloadFile}
                        handleViewClick={handleViewClick}
                        onClickHandler={onClickHandler}
                      />

                      <ClaimProcess
                        handleStaticPageClick={handleStaticPageClick}
                      />
                    </Grid>
                  </Box>
                </Box>
                <Box m={2}>
                  <Box justifyContent="center" className={poweredBy}>
                    <Typography variant={"body1"}><small>POWERED BY</small></Typography>
                  </Box>
                  <Box class={containerLogoGarantie}>
                    <img
                      src={Images.logo}
                      alt="Garantie"
                      className={logoGarantie}
                    />
                  </Box>
                </Box>
              </>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={loaderBox}>
          <CircularProgress color={"secondary"} />
        </Box>
      )}

      <Dialog
        open={modal.open}
        onClose={() => toggleModal("open", false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {NEAREST_SERVICE_CENTRES_LIST}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Grid container spacing={3}>
              {state?.serviceCentres.map((item) => {
                return (
                  <Grid
                    item
                    xs={12}
                    className={
                      item.id ==
                      preferredServiceCentre?.preferred_service_centre?.id
                        ? bgSelected
                        : bgContainer
                    }
                  >
                    <CustomerDetailsField
                      colorClass={"claim_initiated"}
                      label={""}
                      value={item?.name}
                      primaryText={`Contact Number - ${item?.mobile}<br />Email Id - ${item?.email}`}
                      secondaryText={`${item?.address?.address_line_1} ${item?.city} ${item?.state} - ${item?.pincode}`}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant={"contained"}
            size={"small"}
            onClick={() => toggleModal("open", false)}
            color="secondary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>


      <TermsAndCondition
        state={modal.staticPage}
        onclick={() => toggleModal("staticPage", false)}
        body={content?.body}
      />
    </>
  );
}

export default withStyles(useStyles, { withTheme: true })(DashboardComponent);
